import { render, staticRenderFns } from "./case.vue?vue&type=template&id=5c3fa690&"
var script = {}
import style0 from "./case.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "case.vue"
export default component.exports